export function persistOAuthSession(tokenData, role) {
  const accessToken = tokenData?.access_token || tokenData?.access || null;
  const refreshToken = tokenData?.refresh_token || tokenData?.refresh || null;
  const expiresIn = Number(tokenData?.expires_in || 0);

  if (accessToken) {
    localStorage.setItem('access_token', accessToken);
  }
  if (refreshToken) {
    localStorage.setItem('refresh_token', refreshToken);
  }
  if (expiresIn > 0) {
    localStorage.setItem('access_expires_at', String(Date.now() + expiresIn * 1000));
  }
  if (role) {
    localStorage.setItem('user_role', role);
  }
}

export function routeForRole(role) {
  switch (role) {
    case 'artist':
      return '/dashboard/artist';
    case 'host':
      return '/dashboard/host';
    case 'buyer':
      return '/dashboard/buyer';
    default:
      return '/';
  }
}
